import React, { FC, PropsWithChildren, ReactNode } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import { useRuntimeConfig } from "@finbackoffice/site-core";
import Translate from "components/base/translate/Translate";
import ActiveLink from "components/base/active-link/ActiveLink";
import Img from "components/base/img/Img";
import { RouteNames } from "utils/constants";
import styles from "./casino-policies-layout.module.sass";

const CasinoPoliciesMenu: FC = () => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    return (
        <nav className={styles.nav}>
            <ActiveLink href={`/${RouteNames.CASINO}`} activeClassName={styles.active}>
                <>
                    <Img
                        source={`${ASSETS_URL}/common/desktop/base-icons/policies-casino.svg`}
                        alt="Policies Casino"
                        width={20}
                        height={18}
                    />
                    <Translate
                        tid="casino_policies_menu_casino"
                        namespace={TranslationScopes.CasinoPolicies}
                    />
                </>
            </ActiveLink>
        </nav>
    );
};

const CasinoPoliciesLayout: FC<PropsWithChildren> = ({ children }) => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    return (
        <div className={styles.container}>
            <h1 className={styles.header}>
                <Img
                    source={`${ASSETS_URL}/common/desktop/base-icons/policies.svg`}
                    alt="Policies"
                    width={20}
                    height={22}
                />
                <Translate
                    tid="casino_policies_heading"
                    namespace={TranslationScopes.CasinoPolicies}
                />
            </h1>
            <div className={styles.content}>
                <CasinoPoliciesMenu />
                {children}
            </div>
        </div>
    );
};

const getCasinoPoliciesLayout = (page: ReactNode) => (
    <CasinoPoliciesLayout>{page}</CasinoPoliciesLayout>
);

export default getCasinoPoliciesLayout;
